import { render, staticRenderFns } from "./formMenu.vue?vue&type=template&id=1cb9b09c&"
import script from "./formMenu.vue?vue&type=script&lang=js&"
export * from "./formMenu.vue?vue&type=script&lang=js&"
import style0 from "./formMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports